'use strict';

import React from 'react';

import './Title.css';


const Title = ({ element, title, fixed }) => {
  if (element.options.title === false) {
    return null;
  }
  else if (element.options.title && typeof element.options.title === "string") {
    return React.createElement(
      'h1',
      { className: `Title onsched-dark-color ${fixed ? ' fixed' : ''}` },
      element.options.title
    );
  }
  else {
    return React.createElement(
      'h1',
      { className: `Title onsched-dark-color ${fixed ? ' fixed' : ''}` },
      title
    );
  }
}

export default Title;
